/**
 * @return {{Renderer: ({ childs: any }) => any}}
 */
export default function createSlot () {
    const Slot = ( { children, showChildren } ) => showChildren ? children : null;

    Slot.Renderer = ( { childs, children } ) => {
        const slotted = React.Children.toArray ( childs ).find ( child => React.isValidElement ( child ) && child.type === Slot );

        if ( !slotted || !React.isValidElement ( slotted ) ) {
            return children;
        }

        return React.cloneElement ( slotted, { showChildren: true } );
    }

    return Slot
}